// @flow
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './styles';
import messages from './messages';

type Props = {
  text: ?string,
  withButton: boolean,
  buttonLabel: ?string,
  buttonAction: ?Function,
};

type State = {
  isShowing: boolean,
};

class SnackError extends React.PureComponent<Props, State> {
  static defaultProps = {
    text: null,
    withButton: true,
    buttonLabel: null,
    buttonAction: () => {},
  };

  state = {
    isShowing: false,
  };

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        isShowing: true,
      });
    }, 50);
  }

  componentWillUnmount() {
    this.setState({
      isShowing: false,
    });
  }

  render() {
    const { text, withButton, buttonLabel, buttonAction } = this.props;
    const { isShowing } = this.state;
    const isShowingClass = isShowing ? ' showing' : '';

    return (
      <div className={`snack${isShowingClass}`}>
        {withButton && (
          <a onClick={buttonAction}>{buttonLabel || <FormattedMessage {...messages.retry} />}</a>
        )}
        <p>{text || <FormattedMessage {...messages.errorOcurred} />}</p>
        <style jsx>{styles}</style>
      </div>
    );
  }
}

export default SnackError;



// WEBPACK FOOTER //
// ./app/components/mobile/SnackError/component.js